import { AvField, AvForm } from "availity-reactstrap-validation"
import React, { useEffect, useState } from "react"
import { MetaTags } from "react-meta-tags"
import { useDispatch, useSelector } from "react-redux"
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Label,
  Row,
} from "reactstrap"
import PropTypes from "prop-types"

// actions
import { createClient } from "store/actions"
import { get } from "helpers/api_methods"

// components
import Breadcrumbs from "../../../components/Common/Breadcrumb"

const CreateClient = ({ history }) => {
  const dispatch = useDispatch()
  const [categories, setCategories] = useState([])

  const { loading, error } = useSelector(state => ({
    loading: state.Clients.loading,
    error: state.Clients.error,
  }))

  useEffect(() => {
    fetchCategories()
  }, [])

  const fetchCategories = async () => {
    try {
      const res = await get("/order/client-category/")
      if (Array.isArray(res)) {
        setCategories(res)
      } else if (res && res.results) {
        setCategories(res.results)
      }
    } catch (err) {
      console.error("Failed to fetch client categories", err)
    }
  }

  // handleValidSubmit
  const handleValidSubmit = (onSubmitProps, values) => {
    const payload = {
      ...values,
      address: values.address_1 || values.address || "",
    }
    dispatch(createClient(payload, history))
  }

  const mailError = error[0]

  return (
    <>
      <MetaTags>
        <title>Clients | Indtech </title>
      </MetaTags>

      <div className="page-content">
        <Breadcrumbs title="Clients" breadcrumbItem="Create Clients" />
        <Container fluid>
          <div className="container-fluid">
            <Row>
              <Col xl="3"></Col>
              <Col lg={6}>
                <Card>
                  <CardBody>
                    <CardTitle className="h4 mb-4">Fill this form</CardTitle>

                    <AvForm
                      className="form-horizontal "
                      onValidSubmit={(onSubmitProps, v) => {
                        handleValidSubmit(onSubmitProps, v)
                      }}
                    >
                      <div className="row mb-4">
                        <Label
                          htmlFor="horizontal-username-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Name <span className="text-danger">*</span>
                        </Label>
                        <Col sm={9}>
                          <AvField
                            id="horizontal-username-Input"
                            name="name"
                            type="text"
                            placeholder="Enter client name"
                            validate={{
                              required: { value: true, errorMessage: "Please enter client name" },
                            }}
                          />
                        </Col>
                      </div>

                      <div className="row mb-4">
                        <Label
                          htmlFor="category-select"
                          className="col-sm-3 col-form-label"
                        >
                          Category <span className="text-danger">*</span>
                        </Label>
                        <Col sm={9}>
                          <AvField
                            type="select"
                            name="category"
                            id="category-select"
                            className="form-select"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: "Please select a category",
                              },
                            }}
                          >
                            <option value="">Select Category</option>
                            {categories.map(cat => (
                              <option key={cat.id} value={cat.id}>
                                {cat.name}
                              </option>
                            ))}
                          </AvField>
                        </Col>
                      </div>

                      <div className="row mb-4">
                        <Label
                          htmlFor="address1-input"
                          className="col-sm-3 col-form-label"
                        >
                          Address 1
                        </Label>
                        <Col sm={9}>
                          <AvField
                            id="address1-input"
                            name="address_1"
                            type="text"
                            placeholder="optional"
                          />
                        </Col>
                      </div>

                      <div className="row mb-4">
                        <Label
                          htmlFor="address2-input"
                          className="col-sm-3 col-form-label"
                        >
                          Address 2
                        </Label>
                        <Col sm={9}>
                          <AvField
                            id="address2-input"
                            name="address_2"
                            type="text"
                            placeholder="optional"
                          />
                        </Col>
                      </div>

                      <div className="row mb-4">
                        <Label
                          htmlFor="gst-input"
                          className="col-sm-3 col-form-label"
                        >
                          GST Number
                        </Label>
                        <Col sm={9}>
                          <AvField
                            id="gst-input"
                            name="gst_number"
                            type="text"
                            placeholder="optional"
                          />
                        </Col>
                      </div>

                      <div className="row mb-4">
                        <Label
                          htmlFor="tel-input"
                          className="col-sm-3 col-form-label"
                        >
                          Phone
                        </Label>
                        <Col sm={9}>
                          <AvField
                            name="phone"
                            className="form-control"
                            id="tel-input"
                            type="mobile"
                            placeholder="optional"
                            validate={{
                              minLength: {
                                value: 10,
                                errorMessage:
                                  "Your number must be 10 characters",
                              },
                              maxLength: {
                                value: 10,
                                errorMessage:
                                  "Your number must be 10 characters",
                              },
                            }}
                          />
                        </Col>
                      </div>

                      <div className="row mb-4">
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Email
                        </Label>
                        <Col sm={9}>
                          <AvField
                            id="horizontal-email-Input"
                            name="email"
                            className="form-control"
                            type="email"
                            placeholder="optional"
                          />
                        </Col>
                      </div>

                      <div className="row mb-4">
                        <Label
                          htmlFor="horizontal-lastname-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Description
                        </Label>
                        <Col sm={9}>
                          <AvField
                            id="horizontal-lastname-Input"
                            name="description"
                            type="textarea"
                            placeholder="optional"
                          />
                        </Col>
                      </div>

                      <div className="row justify-content-end">
                        <Col sm={9}>
                          <div>
                            {mailError === undefined ? (
                              ""
                            ) : (
                              <Alert color="danger">{error}</Alert>
                            )}

                            <Button
                              type="submit"
                              color="success"
                              className="w-md"
                            >
                              {loading && (
                                <>
                                  <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                                </>
                              )}
                              Submit
                            </Button>
                          </div>
                        </Col>
                      </div>
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
              <Col xl="3"></Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  )
}

export default CreateClient

CreateClient.propTypes = {
  history: PropTypes.object,
}
